// extracted by mini-css-extract-plugin
module.exports = {"single":"ContactInfo-module--single--3Q8FM","arabic":"ContactInfo-module--arabic--2B7eW"};